import React, { useEffect } from 'react';
import styled from 'styled';

import { Confirm } from 'components/ui/modal';

import { connect } from 'containers/store'
import { SharedActionCreators, sharedActionCreators } from 'containers/shared';

import { GettyActionCreators, actionCreators } from 'domains/org/getty/actions';
import { GettyStore } from 'domains/org/getty/store';

import { DeleteStopRequest } from 'generated/mos/org/getty/audiomanagement';
import { Stop, Tour } from 'generated/mos/org/getty/audio'

import { getResolvedValue } from 'helpers/linkables'
import { pick } from 'helpers/core'
import { Status, statusSelector } from 'helpers/status';

import { stopSchema } from '../../../schemas/stop'
import { tourSchema } from '../../../schemas/tour'

type ActionProps =
  Pick<GettyActionCreators, 'gettyDeleteStopRequest'> &
  Pick<SharedActionCreators, 'toastNotification'>;

type ConnectedProps = Pick<GettyStore['getty'], 'stopDelete' | 'stopUpdate'>;

type DirectProps = {
  readonly historyPush: (id: string) => void;
  readonly projectId: string;
  readonly stop: Stop.Entity | undefined;
  readonly tours: ReadonlyArray<Tour.Entity> | undefined;
  readonly onCancel: () => void;
};
type Props = ActionProps & ConnectedProps & DirectProps;

const TourNamesList = styled.ul`
  list-style-position: inside;
  padding: 0;
`;

const StopDeleteView = (props: Props) => {
  const {
    historyPush,
    projectId,
    gettyDeleteStopRequest,
    toastNotification,
    stopDelete,
    stopUpdate,
    onCancel,
    tours,
    stop
  } = props

  const payload: DeleteStopRequest.Entity = {
    ...DeleteStopRequest.defaults,
    stopRef: stop && Stop.mustRef(stop.ref)
  }

  const stopName = stop && getResolvedValue(
    stopSchema.title.read(stop.title),
    statusSelector.hasData(stopUpdate) ? stopUpdate.data.resolvedValues : []
  )

  const modalMessage = (
    <>
      <p>Are you sure you want to permanently delete "{stopName}"?</p>
      { tours && tours.length &&
        <TourNamesList>
        It appears in the following tours:
          {
            tours.map(tour => (
              <li key={tour.ref && tour.ref.id}>
                {tourSchema.name.read(tour.name)}
              </li>
            ))
          }
        </TourNamesList>
      }
    </>
  )

  const onConfirmDelete = () => {
    gettyDeleteStopRequest(payload)
    historyPush(`/project/${projectId}/stops`)
  }

  useEffect(() => {
    if (stopDelete.status === Status.Failed) {
      toastNotification({
        type: 'error',
        text: 'Could not delete stop',
      });
    }
  }, [stopDelete.status]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Confirm
      title="Delete stop?"
      onClose={onCancel}
      message={modalMessage}
      confirmLabel="Delete"
      onConfirm={onConfirmDelete}
      danger
    />
  );
};

export const StopDelete = connect<ConnectedProps, ActionProps, DirectProps, GettyStore, GettyActionCreators>(
  (store) => pick(store.getty, 'stopDelete', 'stopUpdate'),
  {
    ...pick(actionCreators, 'gettyDeleteStopRequest'),
    ...pick(sharedActionCreators, 'toastNotification')
  }
)(StopDeleteView)
